export class RemarkTemplateModel {
    id:number;
    body:string;
    status:string;
    name?: string;
}
